import { Box } from "@mui/material"
import { useMeasurement } from "lib/@hooks/useMeasurement"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { findTask } from "routes/schedule/compare/find-task"
import { TaskOrHeader } from "routes/schedule/tasks/taskOrHeader"
import { AuthoringSideBySideRow } from "./authoring-side-by-side-row"
import { checkAuthoringTaskEquality } from "./lib/check-authoring-task-equality"

export function AuthoringCompareTask({ task }) {
    const [{ width, height }, attach] = useMeasurement()
    const { comparisonTarget, compare } = useBoundContext()
    const originalTask = findTask(compare.tasks, task)
    const otherTask = findTask(comparisonTarget.tasks, task)
    const hasDifference = !otherTask || !checkAuthoringTaskEquality(originalTask, otherTask)

    return (
        <AuthoringSideBySideRow
            dataCy={`side-by-side-task-row-${task.id}`}
            left={<TaskOrHeader last={true} item={task} />}
            right={<RightContent otherTask={otherTask} attach={attach} width={width} height={height} />}
            after={hasDifference ? <Box ml={4} mb={1} /> : null}
        />
    )
}

function RightContent({ otherTask, attach, width, height }) {
    return otherTask ? (
        <Box ref={attach}>
            <TaskOrHeader last={true} item={otherTask} />
        </Box>
    ) : (
        <Box py={1}>
            <Box
                borderRadius={1}
                width={width}
                minWidth={180}
                p={1}
                height={height}
                minHeight={64}
                textAlign="center"
                alignItems="center"
                bgcolor="action.selected"
                display="flex"
                justifyContent="center"
            >
                Not found in this version
            </Box>
        </Box>
    )
}
